module.exports = __webpack_public_path__ + "static/feature-news-efcc4d62c29ea20443145fd8a3eac4b5.png";